import { render, staticRenderFns } from "./AdministracionActividad4.vue?vue&type=template&id=226513ce&"
import script from "./AdministracionActividad4.vue?vue&type=script&lang=js&"
export * from "./AdministracionActividad4.vue?vue&type=script&lang=js&"
import style0 from "./AdministracionActividad4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports